import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAuthorArticles } from '../../ui/src/actions';
import ForOFor from './forOFor';
import { Helmet } from 'react-helmet';
import { Spinner } from '../../ui/src/component/spinner';
import AuthorArticlesComponent from '../../ui/src/component/authorArticles/authorArticles';

class AuthorArticles extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      offset: 0,
    };

    this.handleLoadMoreClick = this.handleLoadMoreClick.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(getAuthorArticles(process.env.REACT_APP_CONTENT_SPACE, this.props.params.authorName, 24, 0));
  }

  handleLoadMoreClick() {
    const { offset } = this.state;
    this.props.dispatch(
      getAuthorArticles(process.env.REACT_APP_CONTENT_SPACE, this.props.params.authorName, 24, offset + 24, true),
    );

    this.setState({
      offset: offset + 24,
    });
  }

  render() {
    const {
      authorArticles,
      author,
      isNotFound,
      nextOffset,
      total,
      isFetching,
    } = this.props;

    if (isNotFound) {
      return <ForOFor />;
    }

    return (
      <div>
        <Helmet>
          {author && <title>{`Všetky články od autora ${author.name}`}</title>}
          {author && (
            <meta
              property="og:title"
              content={`Všetky články od autora ${author.name}`}
            />
          )}
        </Helmet>
        <AuthorArticlesComponent
          authorArticles={authorArticles}
          author={author}
          nextOffset={nextOffset}
          total={total}
          onLoadMoreClick={this.handleLoadMoreClick}
        />
        <Spinner show={isFetching} />
      </div>
    );
  }
}

AuthorArticles.fetchData = ({ store, renderProps }) => {
  store.dispatch(
    getAuthorArticles(renderProps.router.params.authorName, 24, 0),
  );
};

AuthorArticles.propTypes = {
  dispatch: PropTypes.func.isRequired,
  author: PropTypes.object.isRequired,
  authorArticles: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
  nextOffset: PropTypes.number.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isNotFound: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    authorArticles: state.authorArticles.data.articles,
    author: state.authorArticles.data.author,
    total: state.authorArticles.data.total,
    nextOffset: state.authorArticles.data.nextOffset,
    isFetching: state.authorArticles.isFetching,
    isNotFound: state.authorArticles.httpStatus === 404,
  };
};

export default connect(mapStateToProps)(AuthorArticles);



// WEBPACK FOOTER //
// ./src/app/container/authorArticles.js